import * as React from 'react';
import { AppAudioBarProps } from './AppAudioBar.props';
import { Stack } from 'office-ui-fabric-react';
import { getAudioBarStyles, audioBarStackStyles } from './AppAudioBar.styles';
import { FormatTimeDescription, FormatTime } from '../../../utils';

export const AppAudioBar: React.FunctionComponent<AppAudioBarProps> = (props: AppAudioBarProps) => {
  const audioBarRef = React.createRef<HTMLDivElement>();
  const { currentTime, duration, onTimeChange } = props;
  const currentPercentage = Math.min((currentTime / duration) * 100, 100);

  const styles = getAudioBarStyles(currentPercentage);

  const _onBarMouseDown = (event: React.MouseEvent): void => {
    if(!audioBarRef.current) {
      return;
    }

    let audioBarRect = audioBarRef.current.getBoundingClientRect();
    let currentTimeInPercentage = (event.clientX - audioBarRect.left) / audioBarRect.width;

    if(onTimeChange) {
     onTimeChange(currentTimeInPercentage * duration);
    }
  }

  return (
    <Stack horizontalAlign="center" styles={audioBarStackStyles}>
      <div id='audioBar' className={styles.bar} ref={audioBarRef} onMouseDown={_onBarMouseDown} tabIndex={0} aria-label={TranscriptionStrings.PlaybackSeekBarText}>
        <div className={styles.knob} style={{ left: `${currentPercentage - 2}%` }}>
        </div>
      </div>
      <div className={styles.timeContainer}>
        <div><span aria-label={FormatTimeDescription(currentTime, true /* show seconds */)}>{FormatTime(currentTime)}</span></div>
        <div className={styles.duration} aria-label={FormatTimeDescription(currentTime, true /* show seconds */)}>{FormatTime(duration)}</div>
      </div>
    </Stack>
  );
}